
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import supportStyle from "./support.module.css";
import { IoCloudUploadOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;
const BASE_URL = `https://support2.${backend_api_base_url}`;

const SupportForm = () => {
  const history = useHistory();
  const meData = useSelector((state) => state.auth.meData);
  console.log("am getting medata in the support", meData)

  const [formData, setFormData] = useState({
    description: "",
    attachments: [],
    previewUrls: [],
    issueType: "app", // "app" or "generic"
    appId: ""
  });
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apps, setApps] = useState([]);
  const [appsLoading, setAppsLoading] = useState(false);
  const authToken = localStorage.getItem("token");

  useEffect(() => {
    fetchTickets();
    fetchApps();
  }, []);

  const fetchApps = async () => {
    if (!authToken) return;

    setAppsLoading(true);

    try {
      const urls = [
        {
          region: "in",
          url: `https://in.apps2.${backend_api_base_url}/all_apps`,
        },
        {
          region: "us",
          url: `https://us.apps2.${backend_api_base_url}/all_apps`,
        },
      ];

      const results = await Promise.allSettled(
        urls.map(({ url }) =>
          fetch(url, {
            method: "GET",
            headers: {
              Authorization: authToken,
            },
          }).then((res) => {
            if (!res.ok) throw new Error(res.status);
            return res.json();
          })
        )
      );

      let mergedApps = [];

      results.forEach((result, index) => {
        if (result.status === "fulfilled" && Array.isArray(result.value)) {
          const region = urls[index].region;

          const appsWithRegion = result.value.map((app) => ({
            ...app,
            region,
          }));

          mergedApps = [...mergedApps, ...appsWithRegion];
        } else {
          console.error(
            `Failed to fetch apps for region: ${urls[index].region}`
          );
        }
      });

      setApps(mergedApps);
    } catch (err) {
      console.error("Error fetching apps:", err);
    } finally {
      setAppsLoading(false);
    }
  };


  const fetchTickets = async () => {
    if (!authToken) return;
    if (!authToken || !meData) return;

    try {
      // const meRaw = localStorage.getItem("meData");
      // if (!meRaw) return;
      // const me = JSON.parse(meRaw);
      // const tenant = me?.tenant_info?.tenant;

      const tenant = meData?.tenant_info?.tenant;
      if (!tenant) return;

      const res = await fetch(`${BASE_URL}/list?tenant=${tenant}`, {
        headers: { Authorization: authToken },
      });

      if (!res.ok) {
        console.error("Failed to fetch tickets", res.status);
        return;
      }

      const data = await res.json();
      setTickets(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching tickets", err);
    }
  };

  const handleFormChange = (e) => {
    const { name, value, files, type } = e.target;

    if (name === "attachments" && files) {
      const newFiles = Array.from(files);
      const newPreviewUrls = newFiles.map((file) => URL.createObjectURL(file));
      setFormData((prev) => ({
        ...prev,
        attachments: [...prev.attachments, ...newFiles],
        previewUrls: [...prev.previewUrls, ...newPreviewUrls],
      }));
    } else if (type === "radio") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        // Clear appId when switching to generic issue type
        ...(name === "issueType" && value === "generic" && { appId: "" })
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleRemoveImage = (index) => {
    setFormData((prev) => {
      const newAttachments = [...prev.attachments];
      const newPreviewUrls = [...prev.previewUrls];

      try {
        const url = newPreviewUrls[index];
        if (url) URL.revokeObjectURL(url);
      } catch (e) { }

      newAttachments.splice(index, 1);
      newPreviewUrls.splice(index, 1);
      return {
        ...prev,
        attachments: newAttachments,
        previewUrls: newPreviewUrls,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.description.trim()) return;

    const form = new FormData();
    form.append("description", formData.description);
    form.append("issueType", formData.issueType);

    // Only append appId if it's an app-related issue
    if (formData.issueType === "app" && formData.appId.trim()) {
      form.append("appId", formData.appId.trim());
    }

    for (let file of formData.attachments) {
      form.append("attachments", file);
    }

    setLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/add`, {
        method: "POST",
        headers: {
          Authorization: authToken,
        },
        body: form,
      });

      if (res.ok) {
        await res.json();
        formData.previewUrls.forEach((url) => {
          try {
            URL.revokeObjectURL(url);
          } catch (e) { }
        });

        setFormData({
          description: "",
          attachments: [],
          previewUrls: [],
          issueType: "app",
          appId: ""
        });
        fetchTickets();
      } else {
        const error = await res.text();
        console.error("Error submitting ticket:", error);
      }
    } catch (err) {
      console.error("Error submitting form:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={supportStyle.supportWrap}>
      <div className={supportStyle.container}>
        <h3 className={supportStyle.heading}>Raise a Support Ticket</h3>

        <form onSubmit={handleSubmit} className={supportStyle.form}>
          {/* Issue Type Selection */}
          <div className={supportStyle.issueTypeSection}>
            <label className={supportStyle.sectionLabel}>Issue Type</label>
            <div className={supportStyle.radioGroup}>
              <label className={supportStyle.radioLabel}>
                <input
                  type="radio"
                  name="issueType"
                  value="app"
                  checked={formData.issueType === "app"}
                  onChange={handleFormChange}
                  className={supportStyle.radioInput}
                />
                <span className={supportStyle.radioCustom}></span>
                Related to an existing app
              </label>

              <label className={supportStyle.radioLabel}>
                <input
                  type="radio"
                  name="issueType"
                  value="generic"
                  checked={formData.issueType === "generic"}
                  onChange={handleFormChange}
                  className={supportStyle.radioInput}
                />
                <span className={supportStyle.radioCustom}></span>
                Generic issue (Billing/Payment/Other)
              </label>
            </div>
          </div>

          {/* App ID Dropdown - Conditionally Rendered */}
          {formData.issueType === "app" && (
            <div className={supportStyle.appIdSection}>
              <label htmlFor="appId" className={supportStyle.sectionLabel}>
                Select App
              </label>
              {appsLoading ? (
                <div className={supportStyle.loadingText}>Loading apps...</div>
              ) : (
                <select
                  id="appId"
                  name="appId"
                  value={formData.appId}
                  onChange={handleFormChange}
                  className={supportStyle.appIdSelect}
                  required
                >
                  <option value="">Select an app</option>
                  {apps.map((app) => (
                    <option
                      key={`${app.region}-${app.app_id}`}
                      value={`${app.region}`}
                    >
                      {app.app_name} ({app.region.toUpperCase()})
                    </option>

                  ))}
                </select>
              )}
              {apps.length === 0 && !appsLoading && (
                <div className={supportStyle.noAppsText}>
                  No apps found. Please create an app first.
                </div>
              )}
            </div>
          )}

          <textarea
            name="description"
            value={formData.description}
            onChange={handleFormChange}
            placeholder="Describe your issue"
            required
            className={supportStyle.textarea}
          />

          <div className={supportStyle.uploadWrapper}>
            <label htmlFor="fileUpload" className={supportStyle.uploadLabel}>
              <IoCloudUploadOutline className={supportStyle.uploadIcon} />
              Choose File
            </label>
            <input
              id="fileUpload"
              type="file"
              name="attachments"
              multiple
              accept="image/*"
              onChange={handleFormChange}
              className={supportStyle.fileInput}
            />
          </div>

          <div className={supportStyle.preview}>
            {formData.previewUrls.map((url, i) => (
              <div className={supportStyle.previewItem} key={i}>
                <img src={url} alt={`preview-${i}`} />
                <button
                  type="button"
                  className={supportStyle.removeButton}
                  onClick={() => handleRemoveImage(i)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          <button
            type="submit"
            className={supportStyle.submitTicket}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className={supportStyle.loader}></span> Submitting...
              </>
            ) : (
              "Submit Ticket"
            )}
          </button>
        </form>

        <hr />
        <h3>Existing Tickets</h3>
        {tickets.length > 0 ? (
          <ul className={supportStyle.ticketList}>
            {tickets.map((ticket) => (
              <li key={ticket.reference_id}>
                <strong>{ticket.status}</strong> - {ticket.reference_id}
                <button
                  onClick={() =>
                    history.push(`/support/${ticket.reference_id}`)
                  }
                  className={supportStyle.viewDetailsBtn}
                >
                  View Details
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p>No tickets found.</p>
        )}
      </div>
    </div>
  );
};

export default SupportForm;